import Actions from '../constants/Actions';
import {ImmutableStore} from 'fluxible-immutable-utils';

const defaultState = {
  employees: [],
  loaded: false
};

class EmployeeStore extends ImmutableStore {
  static storeName = 'EmployeeStore';

  static handlers = {
    [Actions.EMPLOYEES__LOAD_ALL_STARTED]: 'loadEmployees',
    [Actions.EMPLOYEES__LOAD_ALL_COMPLETED]: 'employeesLoaded'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  loadEmployees() {
    this.mergeState({
      employees: [],
      loaded: false
    });
    this.emitChange();
  }

  getEmployees() {
    return this.get('employees');
  }

  employeesLoaded(data) {
    this.mergeState({
      employees: data,
      loaded: true
    });
  }
}

export default EmployeeStore;



// WEBPACK FOOTER //
// ./src/stores/EmployeeStore.js